import { render, staticRenderFns } from "./index.vue?vue&type=template&id=47abae90&scoped=true"
import script from "./sidebar.js?vue&type=script&lang=js&external"
export * from "./sidebar.js?vue&type=script&lang=js&external"
import style0 from "./index.scss?vue&type=style&index=0&id=47abae90&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47abae90",
  null
  
)

export default component.exports